"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                GlobalSearchPlaceholder_Action: "Search for an action",
                Search_PerformAction: "Perform the selected action",
                Search_ViewResults: "View search results",
            }
        });
        var CombinedActionSearch = /** @class */ (function (_super) {
            __extends(CombinedActionSearch, _super);
            function CombinedActionSearch() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CombinedActionSearch.prototype.Placeholder = function () {
                return $dyn.label("GlobalSearchPlaceholder_Action");
            };
            CombinedActionSearch.prototype.TextChanged = function (args) {
                if (args[0] !== "") {
                    $(this.element.parentNode).addClass("combinedSearch-field-no-placeHolder");
                }
                // this context is the input control inside of the ActionSearch control
                var searchField = this.SearchField;
                searchField.ProcessResults = true;
                var searchText = this.$inputElement[0].value;
                if (searchText) {
                    var searchCallback = function (results) {
                        if (searchField.ProcessResults) {
                            if (results) {
                                var resultsParsed = JSON.parse(results);
                                if (resultsParsed.length) {
                                    searchField.ResultList(resultsParsed);
                                }
                            }
                            else {
                                searchField.ResultList([]);
                            }
                            searchField.openResultPicker();
                        }
                    };
                    var rootForm = $dyn.shell.getCurrentRootForm();
                    var rootFormContext = $dyn.context(rootForm);
                    if (rootFormContext) {
                        $dyn.callFunction(rootFormContext.ExecuteActionSearch, this, [this.$inputElement[0].value], searchCallback);
                    }
                }
            };
            CombinedActionSearch.prototype.clickItem = function (index) {
                this.SelectedIndex(index);
                var rootForm = $dyn.shell.getCurrentRootForm();
                var rootFormContext = $dyn.context(rootForm);
                if (rootFormContext) {
                    var lastActiveControl = $dyn.context(rootFormContext.ActiveElementInMainFormContainer());
                    if (lastActiveControl) {
                        $dyn.callFunction(rootFormContext.UpdateLastSelectedControl, rootFormContext, [lastActiveControl.Name]);
                    }
                    var listItem = this.ResultList()[index];
                    $dyn.callFunction(rootFormContext.ExecuteActionSearchClick, rootFormContext, listItem.Name);
                    this.closeResultPicker();
                }
            };
            return CombinedActionSearch;
        }(controls.CombinedSearchField));
        controls.CombinedActionSearch = CombinedActionSearch;
        // tslint:disable:object-literal-sort-keys
        var actionSearchShortcuts = {
            Enter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function () {
                    if ($dyn.length(this.ResultList) > 0) {
                        // Click the specified button for the selected item
                        if ($dyn.value(this.ShowResultPicker)) {
                            this.ProcessResults = false;
                            // If the drop down is open, call the action search server command for the specified action.
                            var selectedIndex = $dyn.value(this.SelectedIndex);
                            var listItem = this.ResultList()[selectedIndex];
                            var rootForm = $dyn.shell.getCurrentRootForm();
                            var rootFormContext = $dyn.context(rootForm);
                            if (rootFormContext) {
                                $dyn.callFunction(rootFormContext.ExecuteActionSearchClick, this, listItem.Name);
                            }
                            this.closeResultPicker();
                        }
                        else {
                            this.openResultPicker();
                        }
                    }
                },
                RecordTelemetry: false,
                ShowToUser: function () { return ($dyn.length(this.ResultList) > 0); },
                Description: function () {
                    var description = "";
                    if ($dyn.value(this.ShowResultPicker)) {
                        description = $dyn.label("Search_PerformAction");
                    }
                    else {
                        description = $dyn.label("Search_ViewResults");
                    }
                    return description;
                }
            },
        };
        CombinedActionSearch.prototype.Shortcuts = $dyn.extendPrototype(CombinedActionSearch.prototype.Shortcuts, actionSearchShortcuts);
        $dyn.adapter({ id: "CombinedActionSearch", template: "CombinedSearchField" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CombinedActionSearch.js.map
